export const ATTESTATION_REASON_MAX_CHARACTERS = 160;
